import { VENT_CUTOUT_TYPE } from '../engine/managers/cutout-manager/helpers/vent-proxy.helpers';

/** The parts of a kitchen a viewer can be shown as a group. */
export type SceneCategory = 'countertop' | 'surround' | 'appliance' | 'safety';

/**
 * Which `userData.type`s each category lights up. The surround is the island's skin, so it covers the
 * panels AND the corner trims between them; safety is the venting, which is cut INTO the surround
 * rather than modelled, so it lights the cutouts.
 */
export const SCENE_CATEGORY_TYPES: Record<SceneCategory, Array<string>> = {
	countertop: ['countertop'],
	surround: ['panel', 'corner'],
	appliance: ['appliance'],
	safety: [VENT_CUTOUT_TYPE]
};

export const SCENE_CATEGORIES: Array<SceneCategory> = ['countertop', 'surround', 'appliance', 'safety'];
